<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn card-tarja-btn--remove" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television-off</v-icon>
        <span>Remover</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Remover exibição na tarja"
      message="Tem certeza que deseja remover a exibição na tarja?"
      confirmText="Remover"
      cancelText="Manter exibição"
      :loading="loading"
      @confirm="removerColaboracaoTarja"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    idEnquete: Number,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    await this.getConfigTarja({
      cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
    });
    this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_enquete/getConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "tarja_enquete/assignTarjaParams",
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.removerColaboracaoTarja();
      }
    },
    async removerColaboracaoTarja() {
      this.loading = true;

      try {
        await apiClient.patch(`setEnqueteExibicaoTarja/${this.$store.state.producoes.selectedProducao.cod_producao}`, {
          id_enquete: null,
        });

        await apiClient.patch(
            `atualizarFlgIsFullScreenTarjaEnquete/${this.configTarja.id}/${this.$store.state.producoes.selectedProducao.cod_producao}`,
            {
              flg_is_fullscreen: false,
            }
        );

        this.assignTarjaParams(null);
        localStorage.removeItem("tarjaParams");

        this.$emit("change");

      } catch (error) {
        console.error("Error removing enquete from tarja:", error);
        this.$toast.error("Erro ao remover enquete da tarja");
      } finally {
        setTimeout(() => {
          this.loading = false;
          this.showDialog = false;
        }, 250);
      }
    },
  },
  watch: {
    "$store.state.tarja_enquete.configTarjaEnquete": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
  },
};
</script>

